// The patient portal's frame (docs/plans/phase3-portal-feedback-kiswahili.md §7.1): the
// organisation's name, the language switch and, once signed in, Sign out. No staff shell,
// no staff navigation: the portal is a separate area with its own session.
import { SegmentedControl } from '@wodi/ui';
import type { ReactNode } from 'react';

import { isLanguage, useI18n, type Language } from '../i18n/i18n.tsx';
import styles from './portal.module.css';

export function LanguageSwitch({ onChange }: { onChange?: (language: Language) => void }) {
  const { t, language, setLanguage } = useI18n();
  return (
    <SegmentedControl
      aria-label={t('language.label')}
      options={[
        { id: 'en', label: t('language.en') },
        { id: 'sw', label: t('language.sw') },
      ]}
      value={language}
      onChange={(id) => {
        if (!isLanguage(id) || id === language) return;
        setLanguage(id);
        onChange?.(id);
      }}
    />
  );
}

export function PortalFrame({
  organisationName,
  actions,
  onLanguageChange,
  children,
}: {
  organisationName: string;
  actions?: ReactNode;
  onLanguageChange?: (language: Language) => void;
  children: ReactNode;
}) {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <span className={styles.brand}>
            <span className={styles.brandName}>{organisationName}</span>
          </span>
          <div className={styles.headerActions}>
            <LanguageSwitch
              {...(onLanguageChange === undefined ? {} : { onChange: onLanguageChange })}
            />
            {actions}
          </div>
        </div>
      </header>
      <main id="main-content" className={styles.main}>
        {children}
      </main>
    </div>
  );
}
